// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1QRc0","savePackageButton":"ClientWallet_savePackageButton__1dUck"};